import React, { useEffect, useState } from "react";
import { LoginBtn, Menu, MessageBtn, SideBarMenu, SideBarTitle, SideBarWrapper } from "./styles";
import { useHistory } from "react-router-dom";
import { Icon } from "../Main/styles";
import { FaChevronRight } from "react-icons/fa6";
import { useToken } from "app/hooks";
import { LEVEL, useMyInfo } from "CRM/hooks/GetMyInfo";
import { Switch } from "antd";
import { useIsMobile } from "../../components/IsMobile";

export const SideBar = ({ current, view, setMessegeModal, messageSwitch, setMessageSwitch, notiInfo, setView }) => {
	const isMobile = useIsMobile();
	const { data } = useToken();
	const { myInfo, level } = useMyInfo();
	const navigate = useHistory();

	const [menu, setMenu] = useState<any>([]);
	const [totalCount, setTotalCount] = useState<any>(0);

	useEffect(() => {
		if (notiInfo?.totalCount >= 0) {
			setTotalCount(notiInfo?.totalCount);
		}
	}, [notiInfo]);

	const menuClick = (menu) => {
		if (isMobile) {
			setView(false);
		}
		navigate.push("/admin" + menu);
	};

	useEffect(() => {
		let menu: { name: string; url: string }[] = [];
		if (level == LEVEL.MASTER || level == LEVEL.ADMIN) {
			menu = [
				{ name: "HOME", url: "" },
				{ name: "공지사항", url: "/notice" },
				{ name: "DB관리", url: "/db" },
				{ name: "거래고객관리", url: "/customer" },
				{ name: "페이다 입출금", url: "/branch" },
				{ name: "업무요청게시판", url: "/board" },
				{ name: "상태관리", url: "/status" },
				{ name: "방문경로관리", url: "/path" },
				{ name: "플랫폼관리", url: "/platform" },
				{ name: "직원관리", url: "/employee" },
				{ name: "지점관리", url: "/branchManage" },
				{ name: "팀관리", url: "/teamManage" },
				{ name: "설정", url: "/setting" },
			];
			if (!process.env.REACT_APP_URL?.includes("ccl")) menu = menu.filter((v) => v.url !== "/board");
		} else if (myInfo?.boardManager === 1) {
			menu = [
				{ name: "HOME", url: "" },
				{ name: "공지사항", url: "/notice" },
				{ name: "업무요청게시판", url: "/board" },
			];
		} else {
			if (level == LEVEL.LEADER) {
				menu = [
					{ name: "HOME", url: "" },
					{ name: "공지사항", url: "/notice" },
					{ name: "DB관리", url: "/db" },
					{ name: "거래고객관리", url: "/customer" },
					{ name: "페이다 입출금", url: "/branch" },
					{ name: "업무요청게시판", url: "/board" },
				];
			} else if (level == LEVEL.USER) {
				menu = [
					{ name: "HOME", url: "" },
					{ name: "공지사항", url: "/notice" },
					{ name: "DB관리", url: "/db" },
					{ name: "거래고객관리", url: "/customer" },
					{ name: "페이다 입출금", url: "/branch" },
					{ name: "업무요청게시판", url: "/board" },
				];
			} else if (level == LEVEL.BRANCHLEADER) {
				menu = [
					{ name: "공지사항", url: "/notice" },
					{ name: "페이다 입출금", url: "/branch" },
					{ name: "업무요청게시판", url: "/board" },
				];
			} else {
				menu = [
					{ name: "공지사항", url: "/notice" },
					{ name: "페이다 입출금", url: "/branch" },
					{ name: "업무요청게시판", url: "/board" },
				];
			}
		}

		if (!process.env.REACT_APP_URL?.includes("ccl") && LEVEL.MASTER !== level) {
			menu = menu.filter((v) => v.url !== "/board");
			if (!menu.some((v) => v.url == "")) menu.unshift({ name: "HOME", url: "" });
			if (!menu.some((v) => v.url == "/db")) menu.push({ name: "DB관리", url: "/db" });
			if (!menu.some((v) => v.url == "/customer")) menu.push({ name: "거래고객관리", url: "/customer" });
			if (!menu.some((v) => v.url == "/branch")) menu.push({ name: "페이다 입출금", url: "/branch" });
		}

		if (LEVEL.MASTER !== level) {
			menu = menu.filter((v) => v.url !== "");
		}
		setMenu(menu);
	}, [level]);

	return (
		<SideBarWrapper
			style={{
				display: view ? "block" : "none",
				position: isMobile ? "fixed" : "relative",
				zIndex: isMobile ? 9999 : 0,
				height: isMobile ? "9999px" : "",
			}}
		>
			<SideBarTitle>
				메뉴
				<div>
					{data !== "" && (
						<div style={{ display: "flex", alignItems: "center" }}>
							<LoginBtn onClick={() => navigate.push("/admin/logout")}>로그아웃</LoginBtn>
							<MessageBtn
								style={{ marginLeft: 5 }}
								onClick={() => {
									setMessegeModal(true);
								}}
							>{`메세지함(${totalCount})`}</MessageBtn>
							<Switch
								checkedChildren={"ON"}
								unCheckedChildren={"OFF"}
								size={"small"}
								style={{ marginLeft: 5 }}
								checked={messageSwitch}
								onChange={(checked) => setMessageSwitch(checked)}
							/>
						</div>
					)}
				</div>
			</SideBarTitle>
			<SideBarMenu>
				{menu.map((item, index) => {
					return (
						<Menu key={index} onClick={() => menuClick(item.url)} className={current === item.url ? "selected" : ""}>
							{item.name}
							<Icon>
								<FaChevronRight />
							</Icon>
						</Menu>
					);
				})}
			</SideBarMenu>
		</SideBarWrapper>
	);
};

export default React.memo(SideBar);
